import React from "react";
import { DefaultTag } from "@/shared/Components";
import { FileDotsIcon, HeadphonesIcon, MovieIcon, PhotoIcon } from "@/shared/icons";
import styles from "./styles.module.scss";

export type FileType =
  | "pdf"
  | "doc"
  | "docs"
  | "mov"
  | "mp4"
  | "wav"
  | "mp3"
  | "png"
  | "jpg"
  | "jpeg"
  | "svg";

interface Props {
  name: string;
  onClick?: () => void;
  onClose?: () => void;
  type: FileType;
}
export const FileTag: React.FC<Props> = ({ name, type, onClick, onClose }) => {
  const getIcon = (fileType: FileType) => {
    switch (fileType) {
      case "pdf":
      case "doc":
      case "docs": {
        return <FileDotsIcon />;
      }
      case "png":
      case "jpg":
      case "jpeg":
      case "svg": {
        return <PhotoIcon />;
      }
      case "wav":
      case "mp3": {
        return <HeadphonesIcon />;
      }
      case "mov":
      case "mp4": {
        return <MovieIcon />;
      }
      default: {
        return <span></span>;
      }
    }
  };
  return (
    <DefaultTag
      onClose={onClose}
      onClick={onClick}
      closable
      icon={getIcon(type)}
      className={styles["file-tag"]}
    >
      {name}
    </DefaultTag>
  );
};
